import { NgModule, ErrorHandler, APP_INITIALIZER, Inject, Injectable } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule, BrowserTransferStateModule } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { ApplicationStateService } from './services/application-state.service';
import { AppLoadService } from './services/app-load.service';
import { Globals } from './globals';
import { AppModule } from './app.module';
import { JL } from 'jsnlog';

@Injectable()
export class UncaughtExceptionHandler implements ErrorHandler {
  constructor(
  ) { }

  handleError(error: any) {

  }
}

export function init_app(appLoadService: AppLoadService) {
  return () => appLoadService.initializeApp();
}

export function get_user(appLoadService: AppLoadService) {
  return () => appLoadService.getUser();
}

@NgModule({
    imports: [
        CommonModule,
        AppRoutingModule,
        HttpClientModule,
        /*
        ServiceWorkerModule.register('ngsw-worker.js', {
          //enabled: environment.production 
          enabled: true //TESTING FOR LOCAL HOST - JARED 
        }),
        */
        ServiceWorkerModule.register('my-service-worker.js', {
          //enabled: environment.production 
          enabled: true //TESTING FOR LOCAL HOST - JARED 
        }),
        AppModule,
        BrowserTransferStateModule,
    ],
    providers: [
        Globals,
        CookieService,
        { provide: ErrorHandler, useClass: UncaughtExceptionHandler },
        { provide: 'JSNLOG', useValue: JL },
        AppLoadService,
        //{ provide: APP_INITIALIZER, useFactory: init_app, deps: [AppLoadService], multi: true },
        { provide: APP_INITIALIZER, useFactory: get_user, deps: [AppLoadService], multi: true }
    ],
    bootstrap: [AppComponent]
})
export class AppBrowserModule {

}
